import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { Account } from '../../interfaces/Account';

export enum PaidAccountType {
  PaidOut = 'PaidOut',
  PaidIn = 'PaidIn',
}

export function getPaidAccounts(accountType: PaidAccountType): Promise<Account[]> {
  const axiosConfig: AxiosRequestConfig = {
    url: '/account/paid-accounts',
    method: 'GET',
    params: { operationType: accountType },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest(emeraldRequestParams);
}
